import { ParcelTrackingSearchParams } from '@app/models';
import { ParcelShopSearchParams } from '@app/models';
import { LanguageCode } from '@app/models/page';
import { ShippingCountryId } from '@app/models/prices';
import { createReducer, on } from '@ngrx/store';
import * as InputsActions from './actions';

export const featureKey = 'inputs';

export interface State {
	parcelSearchParams: ParcelTrackingSearchParams | null;
	parcelShopSearchParams: ParcelShopSearchParams | null;
	selectedCountry: ShippingCountryId | null;
	_parcelShopSearchParamsUntouched: boolean;
	language?: LanguageCode;
	[K: string]: any;
}

export const initialState: State = {
	parcelSearchParams: null,
	parcelShopSearchParams: null,
	selectedCountry: null,
	_parcelShopSearchParamsUntouched: true,
};

export const reducer = createReducer(
	initialState,

	on(InputsActions.setParcelSearchParams, (state, action) => ({
		...state,
		parcelSearchParams: action.params,
	})),
	on(InputsActions.setParcelShopSearchParams, (state, action) => ({
		...state,
		parcelShopSearchParams: action.params,
		_parcelShopSearchParamsUntouched: false,
	})),
	on(InputsActions.setSelectedCountry, (state, action) => ({
		...state,
		selectedCountry: action.countryId,
	})),

	on(InputsActions.setProp, (state, { key, value }) => ({
		...state,
		[key]: value,
	})),

	on(InputsActions.setLanguage, (state, { language }) => ({
		...state,
		language,
	}))
);
